<template>
  <HubContainer id="menuHub">

    <HubSection icon="icon/hub/settings.svg"
                :title="$t('settings.title')"
                :description="$t('inventory.settings.description')"
                :buttonAction="goToConfigurationHub">
    </HubSection>

    <HubSection icon="icon/hub/taxes-group.svg" v-if="moduleActivated.POS"
                :title="$t('revenue_centers.title')"
                :description="$t('revenue_centers.subtitle')"
                :buttonAction="goToRevenueCenters">
    </HubSection>

    <HubSection icon="icon/hub/brand.svg" v-if="selectedInventory && selectedInventory.brandingActivated"
                :title="$t('branding.title')"
                :description="$t('branding.subtitle')"
                :buttonAction="goToBrandings">
    </HubSection>

    <HubSection icon="icon/hub/ticket.svg" v-if="moduleActivated.aimsVouchers"
                :title="$t('ticket.title')"
                :description="$t('ticket.description')"
                :buttonAction="goToTickets">
    </HubSection>

    <HubSection icon="icon/hub/categories.svg"
                :title="$t('inventory.categories')"
                :description="$t('categories.subtitle')"
                :buttonAction="goToCategories">
    </HubSection>

    <HubSection icon="icon/hub/products.svg"
                :title="$t('inventory.items')"
                :description="$t('items.subtitle')"
                :buttonAction="goToProducts">
    </HubSection>

    <HubSection icon="icon/hub/modifiers.svg"
                :title="$t('inventory.modifiers')"
                :description="$t('inventory.modifiers_hub')"
                :buttonAction="goToModifiersHub">
    </HubSection>

    <HubSection icon="icon/hub/supplements.svg" v-if="moduleActivated.onlineOrdering || moduleActivated.kiosk"
                :title="$t('inventory.supplements')"
                :description="$t('inventory.supplements_description')"
                :buttonAction="goToSupplements">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "MenuHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.catalogs";
      this.$store.state.pageIcon = "/icon/menu.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }
      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      selectedInventory() {
        return this.$store.state.contextInventory;
      }
    },

    methods: {
      goToConfigurationHub() {
        this.$router.push(this.$router.buildContext("/menu/configuration-hub"));
      },
      goToRevenueCenters() {
        this.$router.push(this.$router.buildContext("/revenue-centers"));
      },
      goToBrandings() {
        this.$router.push(this.$router.buildContext("/brandings"));
      },
      goToCategories() {
        this.$router.push(this.$router.buildContext("/categories"));
      },
      goToProducts() {
        this.$router.push(this.$router.buildContext("/items"));
      },
      goToModifiersHub() {
        this.$router.push(this.$router.buildContext("/menu/modifiers-hub"));
      },
      goToTickets() {
        this.$router.push(this.$router.buildContext("/aims-tickets"));
      },
      goToSupplements() {
        this.$router.push(this.$router.buildContext("/supplements"));
      }
    }
  }
</script>